import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Parametro } from '../interfaces/parametro.interface';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ParametroServiceService {
    constructor(private http: HttpClient) {}

    async getParams(url: string): Promise<Parametro[]> {
        const apiUrl = `${environment.apiSiriUrl}${url}`;
        try {
            const data = await firstValueFrom(
                this.http.get<Parametro[]>(apiUrl)
            );
            return data;
        } catch (error) {
            console.error('Error consultando parámetros:', error);
            throw error;
        }
    }

    async updateParam(url: string, id: number, updateData: any): Promise<any> {
        // Reutilizamos putParams pero con la URL completa
        return this.putParams(`${url}/${id}`, updateData);
    }

    // Método existente modificado para ser más flexible
    async putParams(url: string, body: any = {}): Promise<any> {
        const apiUrl = `${environment.apiSiriUrl}${url}`;
        try {
            const data = await firstValueFrom(this.http.patch(apiUrl, body));
            console.log('Parámetro actualizado correctamente');
            return data;
        } catch (error) {
            console.error('Error al actualizar parámetro:', error);
            throw error;
        }
    }
}
